import { render, staticRenderFns } from "./jdyth.vue?vue&type=template&id=1c2caab1&scoped=true"
import script from "./jdyth.vue?vue&type=script&lang=js"
export * from "./jdyth.vue?vue&type=script&lang=js"
import style0 from "./jdyth.vue?vue&type=style&index=0&id=1c2caab1&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2caab1",
  null
  
)

export default component.exports